import React, { useRef, useState } from 'react';
import RequestAdminLocalPW from 'widgets/RequestAdminLocalPW';
import ticketListActions from 'features/ticketList/services/actions';
import { useAppDispatch } from 'store/hooks';
import { IStaffItemData } from 'services/shop/types/staff';
import { FeaturePermission } from 'constants/Permission';
import UnrevokedNoteModal, { UnrevokedNoteRef } from './UnrevokedNoteModal';
import Button from 'components/Button';
import styled from 'styled-components';

const UnrevokedButton = (props: React.ButtonHTMLAttributes<HTMLButtonElement> & { selectedRowKeys: string[]; onSuccess: () => void }) => {
  const [visiblePW, setVisiblePW] = useState(false);
  const dispatch = useAppDispatch();
  const unrevokedNoteModal = useRef<UnrevokedNoteRef>(null);

  const showRequestAdminLocalPW = () => {
    setVisiblePW(true);
  };

  const onUnrevokedTicketSuccess = () => {
    dispatch(ticketListActions.afterDeleteClosedTicket());
    props.onSuccess();
  };

  const onVerifyAdminSuccess = (pin?: string, staffDataVerified?: IStaffItemData) => {
    setVisiblePW(false);
    const billIds = props.selectedRowKeys;
    const data = {
      billIds: billIds,
      staffId: staffDataVerified?.id || '',
    };
    unrevokedNoteModal.current?.open(data, onUnrevokedTicketSuccess);
  };

  return (
    <Container>
      <Button ntype='PRIMARY' onClick={showRequestAdminLocalPW} cardCashier height={3} >
        Unrevoked Bonus
      </Button>
      {visiblePW && (
        <RequestAdminLocalPW
          onlyAdmin
          visible
          v2={true}
          onCorrect={onVerifyAdminSuccess}
          onClose={() => setVisiblePW(false)}
          featureCode={FeaturePermission.DELETE_TICKET}
        />
      )}
      <UnrevokedNoteModal ref={unrevokedNoteModal} />
    </Container>
  );
};

export default UnrevokedButton;

const Container = styled.div`
  .CONTENT_2 {
    font-size: 22px;
    line-height: 1;
  }
`;